import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";

export type ArchiveParamsSlice = {
  archiveFrom: Date | null;
  archiveTo: Date | null;
  changeArchiveFrom: (archiveFrom: Date) => void;
  changeArchiveTo: (archiveTo: Date) => void;
};

const initialData = {
  archiveFrom: null,
  archiveTo: null,
};

export const createArchiveParamsSlice: StateCreator<
  Store,
  [],
  [],
  ArchiveParamsSlice
> = (set) => ({
  ...initialData,
  changeArchiveFrom: (archiveFrom) => set({ archiveFrom }),
  changeArchiveTo: (archiveTo) => set({ archiveTo }),
});
